import { SelectorsFactory } from '../factories/selectors.factory';

export class UsersSelectors extends SelectorsFactory {
  // eslint-disable-next-line no-underscore-dangle
  _byId(id) {
    const { sliceName } = this;
    return (state) => state[sliceName].list.find((e) => e.userId === id);
  }
}

export const usersSelectors = new UsersSelectors('users');
